import React, { cloneElement, useState } from "react";
import {
  List,
  CreateButton,
  SelectInput,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  EditButton,
  useResourceContext,
  useRecordContext,
  useGetOne,
  DateInput,
  EmailField,
  NumberField,
  BooleanField,
  required,
  FunctionField,
} from "react-admin";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import { Scrollbars } from "react-custom-scrollbars";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import Modal from "react-responsive-modal";
import { useLocation } from "react-router-dom";
import { processGatewayCode } from './common';

const Filters = (props) => {
  let locale = getLocalStorageKey("locale");

  return (
    <Filter {...props}>
      <TextInput source="payment_id" label="Payment ID" />
      {/* <TextInput source="currency" defaultValue="" /> */}
      <TextInput source="description" defaultValue="" />
      <SelectInput
        source="payment_status"
        choices={[
          { id: "cancelled", name: "Cancelled" },
          { id: "in-progress", name: "In progress" },
          { id: "successful", name: "Successful" },
        ]}
        validate={required()}
      />
      <TextInput source="bank_reference" defaultValue="" />
      <TextInput source="email" defaultValue="" />
      <TextInput source="mode_of_payment" defaultValue="" />
      {/* <ReferenceInput label="Sold To Name" source="business_id" reference="businesses" allowEmpty>
          <SelectInput source="name" />
        </ReferenceInput> */}
      <ReferenceInput
        label="Sold To Name"
        source="business_id"
        reference="businesses"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      {locale == "ar-EG" ? (
        <NumberInput source="amount" label="Amount" min="0" />
      ) : (
        <NumberInput source="amount" label="Amount" />
      )}
      <DateInput source="bank_payment_date" />
      <SelectInput
        source="is_send_to_sap"
        choices={[
          { id: true, name: "True" },
          { id: false, name: "False" },
        ]}
        validate={required()}
      />
      {locale == "ar-EG" && (
        <DateInput source="date_from" 
        label = "Payment Date From" />
      )}
      {locale == "ar-EG" && (
        <DateInput source="date_to"
        label = "Payment Date To"  />
      )}
      
    </Filter>
  );
};

const textFieldStyle = {
  display: "block",
  width: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );
  // const [ modalShow, setModalShow ] = useState(false);
  // const [ modalMsg, setModalMsg ] = useState('');
  // const [ customFilterUrl, setCustomFilterUrl ] = useState('filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D');

  // const exporterModal = () => {
  //   return ''
  // }

  // const onClose = () => {
  //   setModalShow(false);
  // }

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then(async(res) => {
          if (!res.ok) {
            throw {
              status: res.status,
              res: await res?.json(),
            };
          }
          return res.json();
        })
        .then((jsonD) => {
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        }).catch((error) => {
          Swal.fire({
            html: error.res?.message || "Something went wrong",
            icon: "error",
          });
        })
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then(async(res) => {
          if (!res.ok) {
            throw {
              status: res.status,
              res: await res?.json(),
            };
          }
          return res.json();
        })
        .then((jsonD) => {
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        }).catch((error) => {
          Swal.fire({
            html: error.res?.message || "Something went wrong",
            icon: "error",
          });
        })

      // this.setState(
      //   {
      //     customFilterUrl:
      //       'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
      //   },
      //   () => {
      //     fetch(
      //       `${apiUrl}/${props.resource}_csv?${customFilterUrl}`,
      //       options
      //     )
      //       .then((res) => {
      //         return res.json();
      //       })
      //       .then((jsonD) => {
      //         console.log("json= inside callback", jsonD.data);
      //         const msg = jsonD.data ? jsonD.data[0].message : "";
      //         Swal.fire({
      //           html: msg,
      //           icon: "success",
      //         });
      //         // this.setState({ modalShow: true});
      //         // this.setState({ modalMsg: msg});
      //       });
      //   }
      // );
    }
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
        {/* <CreateButton basePath={resource} /> */}
      </TopToolbar>
      {/* {
          modalShow &&
          <Modal open={modalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        } */}
    </React.Fragment>
  );
};

const postPaymentToSAP = (props) => {
  let dataToSend = {
    payment_intent_id: props?.id,
  };

  console.log("duppppppppppppppppppp", dataToSend, props);

  const options = CommonHeaderOption();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  options.method = "POST";
  options.body = JSON.stringify(dataToSend);
  fetch(`${apiUrl}/post_payment_sap`, options)
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      if (json) {
        console.log("json reply", json, props);
        // setTimeout(()=>{
        if (json.message == "ERROR") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to process your request at this time. Please try again later.",
          }).then((result) => {
            // window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        } else {
          Swal.fire({
            html: "Payment sent to SAP successfully",
            icon: "success",
          }).then((result) => {
            // window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        }
      }
    });
};

const SendToSAPButton = () => {
  const record = useRecordContext();
  return (
    <div>
      <button
        className="ds-button"
        // onClick={()=>setModalDupShow(!modalDupShow)}
        onClick={() => {
          Swal.fire({
            text: "Are you sure you want to send this payment to SAP?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              postPaymentToSAP(record);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }}
      >
        <span>Send to SAP</span>
      </button>
    </div>
  );
};

const downloadJson = (jsonData, filename) => {
  const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const postEgyptPayment = (props) => {
  let dataToSend = {
    payment_intent_id: props?.id,
  };

  console.log("egypttttttt", dataToSend, props);

  const options = CommonHeaderOption();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  options.method = "POST";
  options.body = JSON.stringify(dataToSend);
  fetch(`${apiUrl}/egypt_payment_reponse`, options)
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      if (json) {
        console.log("json reply egypt", json, props);
        
        // setTimeout(()=>{
          
      if (json.data.result == "ERROR") {
          Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Unable to process your request at this time. Please try again later.",
            }).then((result) => {
              });
      } 
      else {
          downloadJson(json.data, `${props?.id}.json`)
        //   Swal.fire({
        //     html: "Downloaded successfully",
        //     icon: "success",
        //   }).then((result) => {
        //   });
        }


      }
    });

}

const DownloadJsonButton = () => {
  const record = useRecordContext();
  return (
    <div>
      <button
        className="ds-button"
        // onClick={()=>setModalDupShow(!modalDupShow)}
        onClick={() => {
          Swal.fire({
            text: "Are you sure you want to download the JSON file?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              postEgyptPayment(record);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }}
      >
        <span>Download Json</span>
      </button>
    </div>
  );
};



const PaymentsList = (props) => {
  
  const CheckStatusButton = () => {
    const record = useRecordContext();
    const [status, setStatus] = useState(record['status'] || '-');
    const [isLoading , setIsLoading] = useState(false);

    console.log('record record record ',record);
    
    return (
      <div className="pay-status-row">
         {
          !isLoading ?
            <button
              className="ds-button"
              // onClick={()=>setModalDupShow(!modalDupShow)}
              disabled={isLoading}
              onClick={() => {
                Swal.fire({
                  text: "Are you sure you want to fetch the status?",
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: "Yes",
                  denyButtonText: "No",
                }).then((result) => {
                  if (result.isConfirmed) {
                    setIsLoading(true);
        
                    let dataToSend = {
                      payment_intent_id: record?.id,
                    };
                  
                    const options = CommonHeaderOption();
                    const apiUrl = RUN_TIME_API_ENDPOINT;
                    options.method = "POST";
                    options.body = JSON.stringify(dataToSend);
                    fetch(`${apiUrl}/egypt_payment_reponse`, options)
                      .then((res) => {
                        return res.json();
                      })
                      .then((json) => {
                        if (json) {
                          console.log("json reply egypt", json);
                          
                          // setTimeout(()=>{
                            
                        if (json.data.result == "ERROR" || json.status == false) {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Unable to process your request at this time. Please try again later.",
                              }).then((result) => {
                                  setIsLoading(false);
                                });
                        } 
                        else {
                          
                          if (Object.keys(json.data).length > 0) {
                            if (json?.data?.transaction.length > 0) {
                              let failedTransactions = json.data.transaction.filter(ft => ft.result != "SUCCESS");
                              let gatewayMessages = processGatewayCode(failedTransactions,'gatewayCode').join(', ');
                              setStatus(gatewayMessages);

                              let passedTransactions = json.data.transaction.filter(ft => ft.result === "SUCCESS");
                              if (passedTransactions.length && failedTransactions.length <= 0) {
                                setStatus('Transaction Approved');
                              }
                            }
                            
                          }
                          setIsLoading(false);
                          
                          //   Swal.fire({
                          //     html: "Downloaded successfully",
                          //     icon: "success",
                          //   }).then((result) => {
                          //   });
                          }
                  
                  
                        }
                      });
                  } else if (result.isDenied) {
                    Swal.fire("Changes are not saved", "", "info");
                    setIsLoading(false);
                  }
                });
              }}
            >
              <span>Check Status</span>
            </button>
            :
            <div className="fetching-txt">Fetching...</div>
         }
        {
          !isLoading && 
            <div className="pay-status-value">{status}</div> 
        }
      </div>
    );
  };
  
  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          bulkActionButtons={false}
          sort={{ field: "id", order: "DESC" }}
          filters={<Filters />}
          title="Payments"
          actions={<ListActions props={props} />}
        >
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source="payment_id" label="Payment ID" />
            <NumberField source="amount" label="Amount (EGP)" />
            {/* <TextField source="currency" /> */}
            <TextField
              source="description"
              style={{ textTransform: "capitalize" }}
            />
            <EmailField source="email" />
            <FunctionField
              source="payment_status"
              render={(record) =>
                record
                  ? record["payment_status"].includes("-")
                    ? record["payment_status"].split("-")[0] +
                    " " +
                    record["payment_status"].split("-")[1]
                    : record["payment_status"]
                  : null
              }
              style={{ textTransform: "capitalize" }}
            />
            {/* <TextField source="status" label="Status" /> */}
            <CheckStatusButton />
            <DateField
              source="created_at"
              label="Payment date"
              showTime
              options={{
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              }}
            />

            <ReferenceField
              label="Sold To Code"
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="sap_code" />
            </ReferenceField>

            <ReferenceField
              label="Sold To Name"
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField source="bank_reference" />
            <DateField
              source="bank_payment_date"
              showTime
              options={{
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              }}
            />
            <TextField source="mode_of_payment" />
            <BooleanField source="is_send_to_sap" />
            <DownloadJsonButton />
            <SendToSAPButton />
          </Datagrid>
        </List>
      </Scrollbars>
    </>
  );
};

export default PaymentsList;
